import {environment} from '../../../../environments/environment';


export class BaseService {
    public readonly baseUrl = environment.baseServiceUrl;
    public readonly baseLoginUrl = environment.baseLoginServiceUrl;
}
